import * as React from 'react';
import { Icon } from '@wix/answers-ui-libby';
import { iconsMap } from '../icons/icons';
import { signupUrl } from '../../helpers/utils';
import { withTranslator } from '../../helpers/shared';
import { TranslateFn } from '@wix/answers-lib';

export type MobileLockProps = {
	isLogin?: boolean;
} & withTranslator;

export class MobileLock extends React.PureComponent<MobileLockProps> {
	compTranslate: TranslateFn = (key, params) => this.props.t(`marketing-site.mobile-lock.${key}`, params);

	render () {
		const {props, compTranslate} = this;
		const classes = `mobile-lock ${props.isLogin ? 'login-mode' : ''}`;
		const maybeLink = props.isLogin ? <p className='helper'>{compTranslate('no-account')}<a href={signupUrl}>{compTranslate('no-account-cta')}</a></p> : null;
		const maybeBottomText = props.isLogin ? null : (
			<div className='bottom-msg-block'>
				<Icon icon={iconsMap.mobileLockBottomScreen}/>
				<p>{compTranslate('bottom-msg')}</p>
			</div>
		);

		return (
			<div className={classes}>
				{props.isLogin ? <h1>{compTranslate('title')}</h1> : null}
				<Icon icon={props.isLogin ? iconsMap.mobileLock : iconsMap.mobileLockSignup} />
				{!props.isLogin ? <h1>{compTranslate('tenant-created-title')}</h1> : null}
				<div className='text-container'>
					<p>{compTranslate(props.isLogin ? 'description' : 'tenant-created-description')}</p>
					{maybeLink}
				</div>
				{maybeBottomText}
			</div>
		);
	}
}
